import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submit"]

    connect() {
        this.enableIfDirty = this.enableIfDirty.bind(this)
        this.element.addEventListener("input", this.enableIfDirty)
        this.element.addEventListener("change", this.enableIfDirty)
    }

    disconnect() {
        this.element.removeEventListener("input", this.enableIfDirty)
        this.element.removeEventListener("change", this.enableIfDirty)
    }

    enableIfDirty() {
        if (!this.hasSubmitTarget) return
        // naive dirty check: any non-empty input or a password toggle opened
        const inputs = this.element.querySelectorAll("input, select, textarea")
        const dirty = Array.from(inputs).some((el) => el.dataset.originalValue !== undefined
            ? el.value !== el.dataset.originalValue
            : el.value && el.value.length > 0)

        this.submitTarget.disabled = !dirty
    }
}